// extracted by mini-css-extract-plugin
export default {"container":"Home_container__UI-rv","content":"Home_content__PvQTM","menu":"Home_menu__IpMLe"};